// components/LoadingSpinner.tsx
import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({
  size = 'sm',
  className = 'me-2',
}) => (
  <Spinner
    as="span"
    animation="border"
    role="status"
    size={size}
    aria-hidden="true"
    className={className}
  />
);

export default LoadingSpinner;
